import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import Axios from 'axios';
import {connect} from 'react-redux';

class Login extends Component {
    constructor(props){
        super(props);
        this.state = {
            userNameOrEmail: '',
            password: '',
            errorText: ''
        }
        this.handleChange = this.handleChange.bind(this);
        this.onLoginSubmit = this.onLoginSubmit.bind(this);
        this.login = this.login.bind(this);
    }

    handleChange({target}) {
        this.setState({ [target.name]: target.value });
    }

    onLoginSubmit(event) {
        event.preventDefault();
        const userNameOrEmail = this.state.userNameOrEmail;
        const password = this.state.password;
        this.login(userNameOrEmail, password);
    }


    login (userNameOrEmail, password) {

        if( (!userNameOrEmail) || (!password)) {
            this.setState( {
                errorText : `Please fill the username and password fields`
            });
            return;
        }

        var loginFormData = new FormData();
        loginFormData.append('email',userNameOrEmail);
        loginFormData.append('password',password);

        Axios.post(`${this.props.properties.loginUrl}`, loginFormData)
        .then((response)=>{
            if(response.status === 200 && (response.headers.authorization)) {
                localStorage.setItem('token',response.headers.authorization);
                this.props.onChangeUser(userNameOrEmail);
            }
            else {
                this.setState( {
                    errorText : `Login Failed: ${response.status }`
                });
            }
         }).catch(err =>  
            { 
                if(err.response && err.response.status === 403) {
                    this.setState( {
                        errorText : 'Invalid email or password.'
                    });  
                }
                
                else {
                    this.setState( {
                        errorText : `An Error Occured. ${err.message}`
                    });
                }
            } 
        );
    }

    render(){

        return (
            <div className="login-pages">
                <div className="container">
                    <div className="row justify-content-md-center">
                        <div className="col-md-7">
                            <div className="login-form-area">
                                <div className="logo">
                                    <img src={process.env.PUBLIC_URL + '/img/template/logo-login.svg'} alt="Logo" />
                                </div>
                                <h1 className="login-title">Login</h1>
                                <div style={{display: this.state.errorText ? "block": "none"}} className="login-result">
                                    {this.state.errorText}
                                </div>
                                <form onSubmit={this.onLoginSubmit}>
                                    <label className="form-label">
                                        <span className="input-title">Email</span>
                                        <input 
                                            className="form-input" 
                                            type="text" 
                                            name="userNameOrEmail" 
                                            defaultValue={this.state.userNameOrEmail} 
                                            autoComplete="off" 
                                            onChange={this.handleChange}
                                        />
                                    </label>
                                    <label className="form-label">
                                        <span className="input-title">Password</span>
                                        <input 
                                            className="form-input" 
                                            type="password" 
                                            name="password" 
                                            defaultValue={this.state.password} 
                                            autoComplete="off" 
                                            onChange={this.handleChange}
                                        />
                                    </label>
                                    <label className="form-label checkbox-label">
                                        <input className="form-checkbox" type="checkbox" defaultValue="1" name="remember" />
                                        <span className="input-checkbox-title">Remember me</span>
                                    </label>
                                    <Link className="forgot-password" to="/forgot-password" title="Forgot Password">Forgot Password?</Link>
                                    <label className="form-label">
                                        <button className="third-button inline">Login</button>
                                    </label>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        properties: state.properties
    }
}

export default connect(mapStateToProps)(Login);